// src/hooks/useAudit.js

import useAuth from "./useAuth";
import { createBusinessAuditLog } from "../sdk/auth/auth";

const useAudit = () => {
  const { auth } = useAuth();

  const logAudit = (payload) => {
    const username = [auth?.user?.firstname, auth?.user?.lastname]
      ?.filter(Boolean)
      ?.join(" ");
    createBusinessAuditLog({
      ...payload,
      username,
      targetUserId: auth?.user?.id,
    });
  };

  return { logAudit };
};

export default useAudit;
